import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminBoxSaleMissingItemPickStrategyPipe } from '../../pipes/admin-box-sale-missing-item-pick-strategy.pipe';
import { AdminBoxSaleMissingItemPickStrategy } from '../../enums/admin-box-sale-missing-item-pick-strategy';

@Component({
  selector: 'app-admin-box-sale-missing-item-pick-strategy',
  imports: [CommonModule, AdminBoxSaleMissingItemPickStrategyPipe],
  templateUrl: './admin-box-sale-missing-item-pick-strategy.component.html',
  styleUrl: './admin-box-sale-missing-item-pick-strategy.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBoxSaleMissingItemPickStrategyComponent {
  public readonly strategy = input.required<AdminBoxSaleMissingItemPickStrategy>();
}
